module.exports = __webpack_public_path__ + "static/media/sept 2021.d9978eb7.svg";